import React from 'react';
import { PaymentData } from '../../../../models';

interface PaymentDataOptionProps {
  paymentData: PaymentData;
}

function PaymentDataOption({ paymentData }: PaymentDataOptionProps) {
  return (
    <div className="flex my-5">
      <div className="w-full  justify-center flex gap-5">
        <span className="font-semibold text-purple-300">
          {paymentData?.name}:
        </span>
        <span>{paymentData?.value}</span>
      </div>
    </div>
  );
}

export default PaymentDataOption;
